import React from "react";

const SPINNER_SIZE_CLASSES = {
  sm: "h-4 w-4",
  md: "h-8 w-8",
  lg: "h-12 w-12",
};

function Spinner({ size = "md", color = "var(--color-brand-accent-fg)" }) {
  const sizeClass = SPINNER_SIZE_CLASSES[size] || SPINNER_SIZE_CLASSES.md;

  return (
    <svg
      className={`inline-block relative shrink-0 ${sizeClass}`}
      style={{ stroke: color }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="status"
      aria-label="Loading"
    >
      <g className="origin-center animate-spinner-rotate">
        <circle
          cx="12"
          cy="12"
          r="9.5"
          fill="none"
          strokeWidth="3"
          className="[stroke-linecap:round] animate-spinner-dash"
        />
      </g>
    </svg>
  );
}

export default Spinner;